import React, { useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import Arrow from './../../../../assets/img/icon/arrow-yellow.svg';
import Style from './style.module.scss';
import useIsMobile from '../../../../hooks/useIsMobile';
import VideoPopup from '../../../../components/videoPopup';

const Hero = ({ targetRef }) => {
  const { t, i18n } = useTranslation();
  const isMobile = useIsMobile();

  const [openVideo, setOpenVideo] = useState(false);

  const handleScroll = () => {
    targetRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <>
      <section className={Style.hero}>
        {isMobile ? (
          <div className={Style.bgMobilePattern}>
            <video autoPlay muted loop playsInline className={Style.video}>
              <source src={'./assets/video/mobilebg.mp4'} type="video/mp4" />
            </video>
          </div>
        ) : (
          <div className={Style.bgPattern}>
            <video autoPlay muted loop playsInline className={Style.video}>
              <source src={'./assets/video/logo.mp4'} type="video/mp4" />
            </video>
          </div>
        )}
        <div className={Style.container}>
          <h1 className={Style.title} dangerouslySetInnerHTML={{ __html: t('homeBanner') }}></h1>
          <button
            className={clsx(Style.snakeButton, {
              [Style.trBtn]: i18n.language === 'tr',
              [Style.enBtn]: i18n.language === 'en',
            })}
            onClick={() => setOpenVideo(true)}
          />
        </div>
        <div className={Style.scrollDown}>
          <button className={Style.scrollBtn} onClick={() => handleScroll()}>
            <img src={Arrow} alt="arrow" />
            {t('scrollDown')}
          </button>
          <VideoPopup isOpen={openVideo} onClose={() => setOpenVideo(false)} />
          <div className={Style.scrollLine} />
        </div>
      </section>
    </>
  );
};

export default Hero;
